import apiHelper from '@/services/helper'

const getAgentByIDs = async (param) => {
    try {
        let url = '/admin/shop/agent/get-by-ids'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getAgentByIDs
}
